import SummaryContent from '@/components/booking-summary/SummaryContent';
import { Icons } from '@/components/icons';
import PriceDisplay from '@/components/PriceDisplay';
import Divider from '@/components/primitives/Divider';
import {
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetRoot,
  SheetTitle,
  SheetTrigger,
} from '@/components/primitives/Sheet';
import { Typography } from '@/components/primitives/Typography';
import type { BookingSummaryData } from '@/hooks/useBookingSummaryData';
import { TransText } from '@/i18n/trans/text';
import type { FC } from 'react';

const MobileBookingSummary: FC<BookingSummaryData> = ({
  displayPrice,
  ...props
}) => {
  return (
    <SheetRoot>
      <SheetTrigger
        data-testid="booking-summary-trigger"
        className="flex w-full flex-row items-center justify-between bg-white"
      >
        <div className="flex flex-row items-center gap-2">
          <Icons.travelPass className="h-4 w-4 text-primary" />
          <Typography variant="body1-bold">
            <TransText i18nKey="bookingSummary" />
          </Typography>
        </div>
        <div className="flex flex-row items-center gap-1 text-primary">
          <Typography variant="body2-bold">
            <PriceDisplay amount={displayPrice?.amount} />
          </Typography>
          <Icons.chevronUp className="h-4 w-4" />
        </div>
      </SheetTrigger>
      <SheetContent data-testid="booking-summary-content" side="bottom">
        <SheetHeader showClose>
          <SheetTitle className="sr-only">
            <TransText i18nKey="bookingSummary" />
          </SheetTitle>
          <SheetDescription className="sr-only">
            <TransText i18nKey="bookingSummary" />
          </SheetDescription>
          <div className="flex flex-row items-center gap-2">
            <Icons.travelPass className="h-5 w-5 text-primary" />
            <Typography variant="subtitle">
              <TransText i18nKey="bookingSummary" />
            </Typography>
          </div>
        </SheetHeader>
        <Divider variant="medium" />
        <div className="max-h-[calc(100vh-170px)] overflow-y-auto">
          <SummaryContent {...props} />
        </div>
        <Divider variant="medium" className="border-primary" />
        <div className="flex flex-row justify-between p-4">
          <div className="flex gap-2">
            <Icons.shoppingCart className="text-primary" />
            <Typography variant="body1-bold">
              <TransText i18nKey="totalPrice" />
            </Typography>
          </div>
          <Typography variant="body1-bold" className="text-primary">
            <PriceDisplay amount={displayPrice?.amount} />
          </Typography>
        </div>
      </SheetContent>
    </SheetRoot>
  );
};

export default MobileBookingSummary;
